import aemClientService from '@/services/aem/aemClientService';
import type {MarketConfigModel} from '@/types/aem';

let config: MarketConfigModel = {};

export const initConfig = async (market: string) => {
    config = {...(await aemClientService.initMarketConfig<MarketConfigModel>(market))};
};

export const getConfig = (): MarketConfigModel => config;
